import React from 'react'
import type { InlineInputContentOptions, InlineInputProps } from '@ztechapps/webui.input'
import { InlineInput } from '@ztechapps/webui.input'
import toNumber from 'lodash/toNumber'
import { QuantityWithUom } from './QuantityWithUom'
import { QuantityInputWithUom } from './QuantityInputWithUom'

type QuantityWithUomInputProps = {
  symbol?: string
  decimalPrecision?: number
}

export const QuantityWithUomInlineInput = ({
  parentInputComponent,
  name = 'quantity',
  inputProps,
  updateParams,
  displayContent,
  validate,
  ...rest
}: InlineInputProps<QuantityWithUomInputProps>) => {
  const ParentInput = parentInputComponent || InlineInput
  const { symbol = '', decimalPrecision = 0 } = inputProps ?? {}

  updateParams =
    updateParams ??
    (({ updatedValue, _id }) => ({
      input: {
        _id,
        [name]: toNumber(updatedValue),
      },
    }))

  return (
    <ParentInput
      {...rest}
      name={name}
      inputProps={inputProps}
      updateParams={updateParams}
      displayContent={
        displayContent ??
        ((value) => <QuantityWithUom quantity={value ?? 0} symbol={symbol} decimalPrecision={decimalPrecision} />)
      }
      editContent={(editProps: InlineInputContentOptions) => (
        <QuantityInputWithUom {...editProps} symbol={symbol} min={1} />
      )}
      validate={
        validate ??
        ((qty) => {
          if (qty <= 0) throw new Error('Cannot be zero or negative.')
        })
      }
    />
  )
}
